import React from 'react';


const ProfileItem = ({ title, description, icon, onClick, fullIcon = false }) => {
  return (
    <div className='profile-item' onClick={onClick}>
      <div className={`profile-item-icon ${fullIcon ? 'full-icon' : ''}`}>
        <img src={icon} alt='Icon' />
      </div>
      <div className='profile-item-info'>
        <span className='profile-item-title'>{title}</span>
        <span className='profile-item-description'>{description}</span>
      </div>
    </div>
  );
};

export default ProfileItem;


